import Vue from "vue";
import VueRouter from "vue-router";
//import authenticate from "../store";

const nprogress = require("nprogress");

Vue.use(VueRouter);

/* function setCookie(name, value,second) {
  var date = new Date();
  date.setTime(date.getTime()+(second*1000));
  var expires = "; expires="+date.toGMTString();
  document.cookie = name+"="+value+expires+"; path=/";
} */
const routes = [
  {
    path: "/",
    name: "",
    meta: {
      title: "Home",
      requiresAuth: false
    },
    component: () => import("@/views/Layout"),
    children: [
      {
        path: "",
        name: "home",
        meta: {
          title: "Home"
        },
        component: () => import("@/views/Home")
      },


      //Faqs
      {
        path: "/faqs",
        name: "faqs",
        meta: {
          title: "Faqs"
        },
        component: () => import("@/views/Faqs"),
        children: []
      },

      //Terms
      {
        path: "/terms",
        name: "terms",
        meta: {
          title: "Terms"
        },
        component: () => import("@/views/Terms"),
        children: []
      },

      //About us
      {
        path: "/aboutus",
        name: "aboutus",
        meta: {
          title: "About Us"
        },
        component: () => import("@/views/Aboutus"),
        children: []
      },

      //Contact
      {
        path: "/contact",
        name: "contact",
        meta: {
          title: "Contact",
        },
        component: () => import("@/views/Contact"),
        children: [],
      },
      //Products
      {
        path: "/products",
        name: "products",
        meta: {
          title: "Products"
        },
        component: () => import("@/views/Products"),
        children: []
      },

      //News
      {
        path: "/news",
        name: "news",
        meta: {
          title: "News"
        },
        component: () => import("@/views/News"),
        children: []
      },

      //News detail
      {
        path: "/news/:new_id",
        name: "news_detail",
        meta: {
          title: "News Detail",
        },
        component: () => import("@/views/News/News_detail"),
        children: [],
      },

      //Video
      {
        path: "videos",
        name: "videos",
        meta: {
          title: "Video"
        },
        component: () => import("@/views/Videos"),
        children: []
      },

      //Application
      {
        path: "/application",
        name: "application",
        meta: {
          title: "Application"
        },
        component: () => import("@/views/Application"),
        children: []
      },
      {
        path: "/my-profile",
        name: "my_profile",
        meta: {
          title: "My Profile",
        },
        component: () => import("@/views/My_profile"),
      },
      //change password
      {
        path: "/change-password/:code",
        name: "change-password",
        meta: {
          title: "Change-password",
        },
        component: () => import("@/views/ChangePassword"),
        children: [],
      },

      //Application detail
      {
        path: "/application/:application_id",
        name: "application_detail",
        meta: {
          title: "Application Detail",
        },
        component: () => import("@/views/Application/Application_detail"),
        children: [],
      },

      //Videos
      {
        path: "/videos/video-detail/:video_id",
        name: "video_detail",
        meta: {
          title: "Video Detail"
        },
        component: () => import("@/views/Videos/Video_detail"),
        children: []
      },
      //Shopping
      {
        path: "/shopping",
        name: "shopping",
        meta: {
          title: "Shopping"
        },
        component: () => import("@/views/Shopping"),
        children: []
      },
      //Ordebes
      {
        path: "/orders",
        name: "orders",
        meta: {
          title: "Orders"
        },
        component: () => import("@/views/Orders"),
        children: []
      },
    ]
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((toRoute, fromRoute, next) => {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
  window.document.title =
    "Capping Group - " +
    (toRoute.meta && toRoute.meta.title ? toRoute.meta.title : "Home");
  /*   if(!toRoute.meta.tmp_conversation_data) {
      localStorage.removeItem('data_conversation')
    } */

  /* if (toRoute.matched.some(record => record.meta.requiresAuth)) {
    next("/");
  } else if (
        toRoute.name === "login" &&
        authenticate.getters["Authenticate/isLoggedIn"]
    ) {
        router.push("/");
        return;
    } else {
    next();
  } */
  next();
});
router.beforeResolve((to, from, next) => {
  if (to.name) {
    nprogress.start();
  }
  next();
});

router.afterEach((to, from) => {
  // Complete the animation of the route progress bar.
  nprogress.done();
});

export default router;
